import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';
import App from './App';
import { setupAxiosSecurity } from './services/axiosSecurity';

// Suprimir erro benigno do ResizeObserver (comum com ReactFlow)
// Este erro ocorre quando o ResizeObserver detecta mudanças de layout durante
// o processamento de callbacks, mas não afeta a funcionalidade da aplicação
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver loop completed with undelivered notifications')) {
    e.stopImmediatePropagation();
    return false;
  }
}, true);

setupAxiosSecurity();

const disableClientCache = async () => {
  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }

    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
    }
  } catch (error) {
    console.error('Falha ao desabilitar caches do cliente:', error);
  }
};

void disableClientCache();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);









